import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT].GET_AVAILABLE_EQUIPMENT]: {
		url: '/company/:companyId/equipment/',
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT].GET_EQUIPMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/',
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT].GET_PREVIEW_EQUIPMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/preview/',
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT].GET_POPUP_EQUIPMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/popup/',
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT].CREATE_EQUIPMENT]: {
		url: '/company/:companyId/equipment/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT].PATCH_EQUIPMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT].PUT_EQUIPMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT].DELETE_EQUIPMENT]: {
		url: '/company/:companyId/equipment/:equipmentId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
